<template>
    <a class="wish-wrapper" :href="urlWishList" rel="nofollow" :aria-label="$translate('Ceres::Template.wishList')">
        <span class="badge-right" :class="{'used': wishListCount > 0}">{{ wishListCount }}</span>
        <i class="fa fa-heart" aria-hidden="true"></i>
    </a>
</template>

<script>
export default {
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
